import classNames from "classnames";
import { LabelledValue } from "components/MobileListRow/LabelledValue";
import { Cell, flexRender, Row } from "react-table-8.10.7";
import { InvoiceItem } from "types/Models/invoice";

type MobileLineItemRowProps = {
  row: Row<InvoiceItem>;
};

// Column ids set on the column helpers in LineItemTable (accessor columns use their key).
const LINE_ITEM_COLUMN_ID = {
  SELECT: "select",
  DESCRIPTION: "description",
  QUANTITY: "quantity",
  RATE: "rate",
  AMOUNT: "amount",
  ACTIONS: "actions",
} as const;

// Matches the checkbox width plus its gap, so the figures line up with the item text.
const CONTENT_INDENT_CLASS = "t-pl-7";

const renderCell = (cell?: Cell<InvoiceItem, unknown>) =>
  cell ? flexRender(cell.column.columnDef.cell, cell.getContext()) : null;

export const MobileLineItemRow = ({ row }: MobileLineItemRowProps) => {
  const cellsById = Object.fromEntries(
    row.getVisibleCells().map((cell) => [cell.column.id, cell])
  );

  const hasSelect = Boolean(cellsById[LINE_ITEM_COLUMN_ID.SELECT]);

  return (
    <div className="t-flex t-flex-col t-gap-2 t-border-0 t-border-b t-border-solid t-border-neutral-0 t-py-3">
      <div className="t-flex t-items-start t-gap-2">
        {renderCell(cellsById[LINE_ITEM_COLUMN_ID.SELECT])}
        <div className="t-min-w-0 t-flex-1 t-text-body-sm t-text-text-100">
          {renderCell(cellsById[LINE_ITEM_COLUMN_ID.DESCRIPTION])}
        </div>
        <div className="t-shrink-0">
          {renderCell(cellsById[LINE_ITEM_COLUMN_ID.ACTIONS])}
        </div>
      </div>

      <div
        className={classNames("t-grid t-grid-cols-3 t-gap-2", {
          [CONTENT_INDENT_CLASS]: hasSelect,
        })}
      >
        <LabelledValue label="Quantity">
          {renderCell(cellsById[LINE_ITEM_COLUMN_ID.QUANTITY]) ??
            row.original.quantity}
        </LabelledValue>
        <LabelledValue label="Unit price">
          {renderCell(cellsById[LINE_ITEM_COLUMN_ID.RATE])}
        </LabelledValue>
        <LabelledValue label="Amount">
          {renderCell(cellsById[LINE_ITEM_COLUMN_ID.AMOUNT])}
        </LabelledValue>
      </div>
    </div>
  );
};
